import summernote from "./summernote.vue";
export default summernote;
